import { Space, Typography, Row, Col } from "antd";
import React from "react";
import {
  BankOutlined,
  CloudDownloadOutlined,
  AudioOutlined,
} from "@ant-design/icons";
import StaticCard from "../../Admin/Card/StaticCard";
import PieChart from "../../Admin/Chart.js/PieChart";
import LineChart from "../../Admin/Chart.js/LineChart";

function OverviewForCensor() {
  // Data for the first pie chart
  const pieData1 = [
    { type: "Copyright Infringement", value: 25 },
    { type: "Illegal content", value: 25 },
    { type: "Privacy violation", value: 25 },
    { type: "Other", value: 25 },
  ];

  // Data for the second pie chart (example data, replace as needed)
  const pieData2 = [
    { type: "Category A", value: 30 },
    { type: "Category B", value: 20 },
    { type: "Category C", value: 25 },
    { type: "Category D", value: 25 },
  ];

  // Data for the line chart
  const lineData = [
    { month: "Jan", reports: 5 },
    { month: "Feb", reports: 8 },
    { month: "Mar", reports: 6 },
    { month: "Apr", reports: 10 },
    { month: "May", reports: 12 },
  ];

  return (
    <div>
      <Typography.Title level={3}>Overview</Typography.Title>
      <Row gutter={16} align="top">
        <Col span={18}>
          <Row gutter={16}>
            <Col span={6}>
              <StaticCard
                cardColor="#FF919D"
                textColor="#242d49"
                iconColor="#242d49"
                title="Total reports"
                amount="10"
                time="This month"
                icon={<AudioOutlined />}
              />
            </Col>
            <Col span={6}>
              <StaticCard
                cardColor="#FF919D"
                textColor="#242d49"
                iconColor="#242d49"
                title="Approve reports"
                amount="3"
                time="This month"
                icon={<BankOutlined />}
              />
            </Col>
            <Col span={6}>
              <StaticCard
                cardColor="#FF919D"
                textColor="#242d49"
                iconColor="#242d49"
                title="Reject reports"
                amount="3"
                time="This month"
                icon={<CloudDownloadOutlined />}
              />
            </Col>
            <Col span={6}>
              <StaticCard
                cardColor="#FF919D"
                textColor="#242d49"
                iconColor="#242d49"
                title="Uncheck reports"
                amount="4"
                time="This month"
                icon={<AudioOutlined />}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: "16px" }}>
            <Col span={24}>
              <LineChart
                data={lineData}
                xField="month"
                yField="reports"
                title="Chart"
                height={350}
                width={800}
              />
            </Col>
          </Row>
        </Col>

        <Col span={6}>
          <Space direction="vertical" size="middle">
            <PieChart data={pieData1} title="Report Type" />
            <PieChart data={pieData2} title="Additional Breakdown" />
          </Space>
        </Col>
      </Row>
    </div>
  );
}

export default OverviewForCensor;
